var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.567,
    height: 15.567,
    viewBox: "0 0 15.567 15.567",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-gift",
    "data-name": "Icon feather-gift",
    transform: "translate(-2.5 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86408",
    "data-name": "Path 86408",
    d: "M17.654,18v7.284H6V18",
    transform: "translate(-1.543 -7.716)",
    fill: "none",
    stroke: "#2acbae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86409",
    "data-name": "Path 86409",
    d: "M3,10.5H17.567v3.642H3Z",
    transform: "translate(0 -3.858)",
    fill: "none",
    stroke: "#2acbae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86410",
    "data-name": "Path 86410",
    d: "M18,21.426V10.5",
    transform: "translate(-7.716 -3.858)",
    fill: "none",
    stroke: "#2acbae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86411",
    "data-name": "Path 86411",
    d: "M12.6,6.642H9.321A1.821,1.821,0,1,1,9.321,3C11.87,3,12.6,6.642,12.6,6.642Z",
    transform: "translate(-2.315)",
    fill: "none",
    stroke: "#2acbae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86412",
    "data-name": "Path 86412",
    d: "M18,6.642h3.278a1.821,1.821,0,1,0,0-3.642C18.728,3,18,6.642,18,6.642Z",
    transform: "translate(-7.716)",
    fill: "none",
    stroke: "#2acbae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIcon);
export default __webpack_public_path__ + "static/media/gift-icon.7183a47dc8231f651a8748f5d2444795.svg";
export { ForwardRef as ReactComponent };